import { gql } from '@apollo/client';

export const AscWageFragment = gql`
  fragment AscWage on AscWage {
    id
    name
    titles
    departments
    managerNames
    hireDates
    terminationDates
    costCenters
    entities
    totalCompensationCents
    salaryCompensationCents
    stockCompensationCents
    capitalizedTotalCompensationCents
    allocationPercent
    countries
    contributorId
    hasCompleteDataInPeriod
    fiscalYearId
    periodName
  }
`;
